$(document).ready(function() {
    $('#system-logs-container').on('click', '.btn-show-log-details', function() {
        $("#system-logs-container table tr").removeClass('selected')
        let hash = $(this).data('hash')
        $(this).closest('tr').addClass('selected')

        makeRequest('/system/logs/' + hash, {}, function (response){
            if(response.success && response.details) {
                $('#log_group_detail_window').text(response.details);
            }
            else {
                error_message();
            }
        });
    });
});
